import { Section } from "@models/ISchema";

export const getOriginalWeeksBySessionId = (
  sections: Section[],
): { [sessionId: string]: string[] } => {
  const result: { [sessionId: string]: string[] } = {};
  (sections ?? []).forEach(section => {
    const allSessions = [...(section.sessions ?? []), ...(section.unasignedSessions ?? [])];
    allSessions.forEach(session => {
      result[session.id] = (session.assignment?.intervals ?? [])
        .slice()
        .sort((a, b) => (a.id || "").localeCompare(b.id || ""))
        .map(interval => interval.id || "");
    });
  });
  return result;
};
